export default __webpack_public_path__ + "static/media/icon-512x512.0811f38d.png";